<template>
  <div
    class="mt-6 rounded-2xl overflow-hidden"
    style="border: 1px solid #2a2e30"
  >
    <!-- Header -->
    <div
      class="flex items-center justify-between px-4 py-2.5"
      style="background: #1e2224"
    >
      <!-- Tabs (multi) or plain label (single) -->
      <div class="flex items-center gap-1">
        <template v-if="tabs">
          <button
            v-for="tab in tabs"
            :key="tab.label"
            class="px-3 py-1 rounded-lg font-[Poppins] font-bold text-[11px] border-none cursor-pointer transition-all duration-150"
            :style="
              activeTab === tab.label
                ? { background: 'rgba(20,184,166,0.18)', color: '#14b8a6' }
                : { background: 'transparent', color: '#6c7a77' }
            "
            @click="activeTab = tab.label"
          >
            {{ tab.label }}
          </button>
        </template>
        <span
          v-else
          class="font-mono text-[11px] text-[#6c7a77] tracking-[0.5px]"
          >{{ lang }}</span
        >
      </div>
      <!-- Copy button -->
      <button
        class="flex items-center gap-1.5 px-3 py-1 rounded-lg font-[Poppins] font-bold text-[11px] border-none cursor-pointer transition-all duration-150"
        :style="{
          background: copied ? '#14b8a6' : 'rgba(255,255,255,0.07)',
          color: copied ? 'white' : '#a0b0ae',
        }"
        @click="copy"
      >
        <Check v-if="copied" :size="11" />
        <Copy v-else :size="11" />
        {{ copied ? "Kopierad!" : "Kopiera" }}
      </button>
    </div>
    <!-- Code -->
    <pre
      class="m-0 px-5 py-4 overflow-x-auto text-[13px] leading-[1.7] font-mono"
      style="background: #161a1c; color: #cdd6d4"
    ><code>{{ activeCode }}</code></pre>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { Copy, Check } from "lucide-vue-next";

const props = defineProps({
  // Single-snippet usage: <CodeBlock :code="..." lang="vue" />
  code: { type: String, default: null },
  lang: { type: String, default: "vue" },
  // Multi-tab usage: <CodeBlock :tabs="[{ label: 'HTML', code: '...', lang: 'html' }, ...]" />
  tabs: { type: Array, default: null },
});

const activeTab = ref(props.tabs?.[0]?.label ?? null);

const activeCode = computed(() => {
  if (props.tabs) {
    return props.tabs.find((t) => t.label === activeTab.value)?.code ?? "";
  }
  return props.code ?? "";
});

const copied = ref(false);

async function copy() {
  await navigator.clipboard.writeText(activeCode.value);
  copied.value = true;
  setTimeout(() => {
    copied.value = false;
  }, 2000);
}
</script>
